// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ffda5e1a","940":"c7df08fe"}[chunkId] + ".chunk.js";
};